module.exports = __webpack_public_path__ + "static/media/scoliosis_mild_left.b62b52c1.png";